import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-expanded-payment-history-detail-dialog',
    template: require('./dialogAmenityNote.html')
})
export class AmenityNoteDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<AmenityNoteDialog>) public dialogRef: MatDialogRef<AmenityNoteDialog>) {
        dialogRef.updateSize("430px");
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
